<template lang="html">
  <div class="judge">
    <div class="answer_code">
      <div class="topic_name">
        <p class="topic_number">
          <span class="this_num">{{judge.seq}}</span>
          <span class="all_num">/</span>
          <span class="all_num">{{allTopic}}</span>
        </p>
        <p class="topic_type">{{judge.type_name}}</p>
      </div>
      <div class="testQuestions_con" >
        <div class="testQuestions">
          {{judge.content}}
        </div>
        <div class="option">
          <div class="" v-for="(b, index) in judge.choices" :key="index">
            <div class="" v-if="b.option_value == 1">
              A)<span>{{b.content}}</span>
            </div>
            <div class="" v-else>
              B)<span>{{b.content}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="select">
        <div class="select_btn">
          <div>
            <img src="../../../assets/image/exam/option_a.png" alt="" v-show="optionA" @click="getRadioVal(judge.choices[0].option_value)">
            <img src="../../../assets/image/exam/optionA.png" alt="" v-show="optiona" @click="recover(judge.choices[0].option_value)">
          </div>
          <div>
            <img src="../../../assets/image/exam/option_b.png" alt="" v-show="optionB" @click="getRadioVal(judge.choices[1].option_value)">
            <img src="../../../assets/image/exam/optionB.png" alt="" v-show="optionb" @click="recover(judge.choices[0].option_value)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['judge', 'allTopic'],
  data(){
    return{
      optionA: true,
      optiona: false,
      optionB: true,
      optionb: false,
      picked: [],
    }
  },
  mounted(){
    
  },
  methods:{
    getRadioVal(num) {
      if(num == 1){
        this.optionA = false;
        this.optiona = true;
        this.optionB = true;
        this.optionb = false;
      }else if(num == 0){
        this.optionA = true;
        this.optiona = false;
        this.optionB = false;
        this.optionb = true;
      }
      this.$parent.fatherMethod(this.judge.question_id, [num]);
    },
    recover(num){
      var a = this.picked.indexOf(num);
      if(num == 1){
        this.optionA = true;
        this.optiona = false;
        this.picked.splice(a,1);
        this.$parent.fatherMethod(this.judge.question_id, this.picked);
        return this.picked;
      }
      if(num == 0){
        this.optionB = true;
        this.optionb = false;
        this.picked.splice(a,1);
        this.$parent.fatherMethod(this.judge.question_id, this.picked);
        return this.picked;
      }
    },
  }
}
</script>

<style lang="css" scoped>
.answer_code{
  box-sizing: border-box;
  width: 100%;
  height: 56rem;
  background: url("../../../assets/image/exam/code_back.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 7.5rem;
  padding-left: 3rem;
  padding-right: 3rem;
  position: relative;
}

.topic_name{
  display: flex;
  align-items: center;
}
.topic_number{
  display: flex;
  align-items: center;
}
.this_num{
  font-size: 2.4rem;
  color: #7966CA;
}
.all_num{
  font-size: 1.8rem;
  color: #A6A9BA;
  padding-top: .3rem;
}
.topic_type{
  margin-left: .8rem;
  font-size: 1.6rem;
  color: #7966CA;
}

/* 试题 */
.testQuestions{
  font-size: 1.6rem;
  color: #1D2023;
  margin-top: 1rem;
}
.option{
	height: 30rem;
  font-size: 1.6rem;
  color: #3F454B;
	overflow: auto;
}
.option div{
  margin-top: 2rem;
}
.option span{
  margin-left: 1rem;
}
.select{
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: 3rem;
  padding-right: 3rem;
}
.select_btn{
  display: flex;
  justify-content: center;
  padding-bottom: 2rem;
}
.select_btn img{
  width: 5.1rem;
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
</style>
